<template>
    <b-col md="3" class="d-none d-lg-block" v-if="brands.length || childrenCategories.length || variations.length">
        <div class="sidebar-categories">
            <div class="sidebar-categories-block pb-5">
                <template v-if="$route.name === 'busca'">
                    <div class="sidebar-categories-title mb-4 text-capitalize">Fltrar</div>
                    <hr class="sidebar-categories-line mb-4">
                </template>
                <template v-if="childrenCategories.length">
                    <div class="sidebar-categories-title mb-4 text-capitalize"> {{ childrenCategories.length ? 'Categorias' : alias}}</div>
                    <hr class="sidebar-categories-line mb-4">
                    <div v-if="childrenCategories.length" class="mb-md-5">
                        <div class="sidebar-categories-name mb-3">{{childrenCategories[0].name}}</div>
                        <div v-for="(item, index) in childrenCategories[0].subitems" class="pb-2" v-if="index < visibleCategories">
                            <div class="d-flex align-items-center">
                                <nuxt-link :to="`/categoria/${childrenCategories[0].alias}/${item.alias}`" class="sidebar-categories-link" :class="item.alias == current_subcategory ? 'sidebar-categories-link-visited' : ''"> {{ item.name }}</nuxt-link>
                                <button class="ml-auto py-0 px-2 mr-2" @click="visibles[item.code] = !visibles[item.code]" v-if="item.subitems.length">
                                    <template v-if="visibles[item.code]">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="3">
                                            <rect width="14" height="3"/>
                                        </svg>
                                    </template>
                                    <template v-else>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" class="call-center-accordion-btn-icon">
                                            <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/>
                                        </svg>
                                    </template>
                                </button>
                            </div>
                            <b-collapse v-if="item.subitems.length" v-model="visibles[item.code]">
                                <ul class="list-unstyled m-1">
                                    <li v-for="subitem in item.subitems" class="pl-2 pb-1">
                                        <nuxt-link :to="`/categoria/${childrenCategories[0].alias}/${item.alias}/${subitem.alias}`" class="sidebar-categories-link" :class="subitem.alias == current_subcategory ? 'sidebar-categories-link-visited' : ''"> {{ subitem.name }}</nuxt-link>
                                    </li>
                                </ul>
                            </b-collapse>
                        </div>
                        <div v-if="childrenCategories[0].subitems.length > categoriesToShow" class="sidebar-categories-colapse-btn pt-2">
                            <span @click="colapseCategoryList" class="font-italic p-2">{{!isColapsed ? "Ver mais" : "Ver menos"}}</span>
                        </div>
                    </div>
                </template>
<!--            <ProductsFilterCategories :categories="categories" v-if="categories"/>-->
                <ProductsFilterBrands :brands="brands" v-if="brands"/>
                <ProductsFilterAttributes :attributes="attributes" v-if="attributes"/>
                <ProductsFilterVariations :variations="variations" v-if="variations"/>
            </div>
        </div>
    </b-col>
</template>

<script>
    import ProductsFilterBrands from "~/components/Products-filter-brands";
    import ProductsFilterAttributes from "~/components/Products-filter-attributes";
    import utils from "~/mixins/utils";
    import categories from "~/mixins/categories";
    import ProductsFilterCategories from "~/components/Products-filter-categories";
    import ProductsFilterVariations from "~/components/Products-filter-variations";

    export default {
        components: {
            ProductsFilterVariations,
            ProductsFilterCategories,
            ProductsFilterAttributes,
            ProductsFilterBrands,
        },
        props: [
            'categories',
            'alias',
            'brands',
            'attributes',
            'variations'
        ],
        mixins: [
            utils,
            categories
        ],
        data() {
            return {
                childrenCategories: [],
                current_subcategory: '',
                current_category: '',
                visibles: {},
                isColapsed: false,
                visibleCategories: null
            }
        },
        mounted() {
            this.visibleCategories = this.categoriesToShow
            const current_route = this.$route.path.split('/')
            if (current_route.length) {
                this.current_category = current_route[2]
                if (current_route.length > 2) {
                    this.current_subcategory = current_route[3]
                }
                this.childrenCategories = this.$store.state.categories.filter((element) => {
                    return element.alias == this.current_category
                })
            }
        },
        methods: {
            colapseCategoryList() {
                this.isColapsed = !this.isColapsed;
                if (this.isColapsed) {
                    this.visibleCategories =
                        this.childrenCategories[0].subitems.length;
                } else {
                    this.visibleCategories = this.categoriesToShow;
                }
            },
    },
    }
</script>
